module.exports = __webpack_public_path__ + "img/pr-6.14db9052.png";